// extracted by mini-css-extract-plugin
module.exports = {"activityText":"widget-space--activityText--24N4T","md":"widget-space--md--2PLNq"};